import React from 'react'
import { useFetch } from '../../../hooks'

const ToastRemoveUndo = ({ data, url, redirect, history, translation }) => {
    const { doFetch } = useFetch({
        url,
        method: 'POST'
    })

    const removeCowUndo = async () => {
        try {
            await doFetch({ data })
            redirect && history.push({
                pathname: redirect,
                state: {
                    refetch: true
                }
            })
        } catch (error) {
        }
    }
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>{translation && translation['info-confirm']}</span>
            <span style={{ cursor: 'pointer' }} onClick={removeCowUndo}>{translation && translation.buttons.undo}</span>
        </div>
    )
}

export default ToastRemoveUndo
